import { createContext } from "react";

export const CardContext = createContext({ hiddenPrice: false });
CardContext.displayName = "CardContext";

export function CardContextProvider({ hiddenPrice = false, children }) {
  return (
    <CardContext.Provider value={{ hiddenPrice }}>
      {children}
    </CardContext.Provider>
  );
}
